import React from 'react';
import { Typography } from '@/components/common';
import { ContainerBase } from '../containers';
import { Title } from '../title';

export const OurMission: React.FC = () => {
	return (
		<ContainerBase>
			<section className="!mt-10 ">
				<div className="flex flex-col justify-center items-center relative overflow-hidden bg-grey-5 rounded-[32px] lg:rounded-[64px] w-full py-10 lg:py-20 lg:pb-14 px-8 lg:px-5 lg:h-[407px]">
					<div className="absolute inset-0 rounded-[32px] lg:rounded-[64px] bg-[url(/img/landing/bg-ready-mobile.svg)] lg:bg-[url(/img/landing/bg-ready.svg)] bg-cover bg-no-repeat z-0" />
					<div className="relative z-10">
						<Title>
							<span className="text-white">Our</span> Mission
						</Title>
						<Typography
							type="regular-20"
							className="text-center mt-6 lg:mt-14 lg:max-w-[832px] mx-auto"
						>
							Our mission is to hold corporations accountable and ensure that
							everyday people get the compensation they deserve. Claim Magic
							exists to make justice accessible, transparent, and effortless for
							everyone.
						</Typography>
					</div>
				</div>
			</section>
		</ContainerBase>
	);
};
